import {
  resolveTenantModules,
  TENANT_MODULE_KEYS,
  TENANT_MODULE_LABELS,
  type TenantModules,
} from "@loot-os/api-contract";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@loot-os/ui/components/tooltip";

import { TENANT_MODULE_ICONS } from "../lib/tenantModuleIcons";

/**
 * A row of module icons: the primary color while the tenant has the module, muted while it does
 * not. Shows what the gates answer, so a storefront module reads off while the storefront is off
 * even if its own switch is on. Each icon names its module and state in a tooltip on hover (one
 * provider, so moving along the row shows the next at once) and to a screen reader.
 */
export function TenantModuleIcons({ switches }: { switches: TenantModules }) {
  const modules = resolveTenantModules(switches);
  return (
    <TooltipProvider>
      <ul className="flex items-center gap-1.5">
        {TENANT_MODULE_KEYS.map((key) => {
          const Icon = TENANT_MODULE_ICONS[key];
          const on = modules[key];
          const label = `${TENANT_MODULE_LABELS[key]}: ${on ? "enabled" : "disabled"}`;
          return (
            <li key={key}>
              <Tooltip>
                <TooltipTrigger render={<span className="flex cursor-default" />}>
                  <Icon
                    aria-hidden
                    className={`size-4 ${on ? "text-primary" : "text-muted-foreground/40"}`}
                  />
                  <span className="sr-only">{label}</span>
                </TooltipTrigger>
                <TooltipContent>
                  {TENANT_MODULE_LABELS[key]}
                  <span className="opacity-70">
                    {" · "}
                    {on ? "Enabled" : switches[key] ? "Off with the storefront" : "Disabled"}
                  </span>
                </TooltipContent>
              </Tooltip>
            </li>
          );
        })}
      </ul>
    </TooltipProvider>
  );
}
